import { observer } from "mobx-react-lite";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useStore } from "../stores/store";
import { useCallback, useEffect, useState } from "react";
import AuthorizedLayout from "../../features/layout/auth/AuthorizedLayout";
import Loading from "./Loading";
import IndexHomePage from "../../features/home/IndexHomePage";
import { useIdleTimer } from "react-idle-timer";
import DuplicateTab from "./DuplicateTab";
import ResolvePages from "./ResolvePages";
import { faro } from "@grafana/faro-react";
import agent from "../api/agent";
import { UserProfile } from "../models/user";

function App() {
  const location = useLocation();
  const [noTab, setNoTab] = useState(false);
  const [tabLoad, setTabLoad] = useState(true);
  const { commonStore, userStore } = useStore();
  const { isLoggedIn, remainingTime, tokenRefresh, token, setAppLoaded } =
    commonStore;
  const { logout } = userStore;
  const [isPrompt, setIsPrompt] = useState(false);

  const onPrompt = () => {
    setIsPrompt(true);
    toast.warn(
      "Your session will expire in 1 minute due to inactivity"
    );
  };

  
  
  useEffect(()=> {
    if(isLoggedIn){
      const encryptedProfile = localStorage.getItem("user")!
      let decryptedProfile: UserProfile | null = null;

      if (encryptedProfile) {
        try {
          decryptedProfile = agent.decryptResponse(encryptedProfile) || null;
        } catch (error) {
          console.error("Decryption failed", error);

          decryptedProfile = null; // Set to null if decryption fails
        }
      }
      faro.api.setUser({
        // Optional, if you want to pass the user ID
     id:  decryptedProfile ? decryptedProfile.userId : "",
     
     // Optional, if you want to pass the user email
     email: decryptedProfile ? decryptedProfile.email : "",
     
    //  // Optional, if you want to pass the username
     username: decryptedProfile ? decryptedProfile.firstName : "", 
     
    //  // Optional, if you want to set custom attributes
    //  attributes: {
    //    'my-custom-attribute': 'my-custom-attribute-value',
    //  },
      })
    }

  }, [isLoggedIn])


  const onIdle = () => {
    setIsPrompt(false);
    userStore.logout();
    toast.info(
      "Your session has expired due to inactivity, please login again"
    );
  };

  useIdleTimer({
    timeout: 1000 * 60 * 5,
    promptBeforeIdle: 1000 * 60 * 1,
    onPrompt,
    onIdle,
    disabled: !isLoggedIn,
  });

  const calculateTimeLeft = useCallback(() => {
    return remainingTime();
  }, [remainingTime]);

  
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [refresh, setRefresh] = useState(true);



  // useEffect(() => {
  //   function onlineHandler() {
  //     // setIsOnline(true);
  //     toast.success("Connected");
  //   }

  //   function offlineHandler() {
  //     // setIsOnline(false);
  //     toast.warning("No internet connection");
  //   }

  //   window.addEventListener("online", onlineHandler);
  //   window.addEventListener("offline", offlineHandler);

  //   return () => {
  //     window.removeEventListener("online", onlineHandler);
  //     window.removeEventListener("offline", offlineHandler);
  //   };
  // }, []);

  // refresh token use Effect
  useEffect(() => {
    if (token && token !== null) {
      let timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 10000);

  
      setAppLoaded();
  
      if (timeLeft > 0 && timeLeft < 120000 && refresh) {
        // setRefresh(true); // Make sure you are setting it to false only once per cycle
        try {
          // console.log("Attempting token refresh...");
          // tokenRefresh();  // Ensure this function works properly
        } catch {
          // logout();
          // setRefresh(false);
          // setTimeLeft(0);
          // toast.info("Your session has expired, please login again");
        }
      } else if (timeLeft < 0) {
        // logout();
        // setTimeLeft(0);
        // setRefresh(false)
        // toast.info("Your session has expired, please login again");
      }
  
      return () => clearTimeout(timer);
    } else {
      setAppLoaded();
    }
  }, [
    token,
    logout,
    setAppLoaded,
    timeLeft,
    refresh,
    setRefresh,
    tokenRefresh,
    setTimeLeft,
    calculateTimeLeft,
  ]);
  

  // helper function to set cookies
  var setCookie = (cname: string, cvalue: number, seconds: number) => {
    var d = new Date();
    d.setTime(d.getTime() + seconds * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  // helper function to get a cookie
  var getCookie = (cname: string) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
  // use effect to handle multiple tabs
  useEffect(() => {
    setTabLoad(false);
    document.cookie = "ic_window_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    const validateCallCenterTab = () => {
      const win_id_cookie_duration = 10; // in seconds
      if (!window.name) {
        window.name = Math.random().toString();
      }

      if (!getCookie("ic_window_id") || window.name === getCookie("ic_window_id")) {
        setCookie("ic_window_id", Number.parseFloat(window.name), win_id_cookie_duration);
      } else if (getCookie("ic_window_id") !== window.name) {
        setNoTab(true);
        clearInterval(callCenterInterval); // Prevent further checking
      }
    };

    const callCenterInterval = setInterval(validateCallCenterTab, 2000);
    return () => clearInterval(callCenterInterval); // Cleanup on unmount

  }, []);

  if (tabLoad) return <Loading />;
  if (noTab) return <DuplicateTab />;
  if (!commonStore.appLoaded) return <Loading />;
  return (
    <>
      <ScrollRestoration />
      <ToastContainer position="top-right" hideProgressBar theme="colored" />
      <ResolvePages path={location.pathname} />
      {/* {location.pathname === "/" ? (
        <IndexHomePage />
      ) : location.pathname === "/login" ||
        location.pathname === "/register" ||
        location.pathname === "/callback" ||
        location.pathname === "/change-password" ||
        location.pathname === "/verifyemail" ||
        location.pathname === "/vendors" ||
        location.pathname.includes("/vendors/") ||
        location.pathname === "/not-found" ? (
        <Outlet />
      ) : (
        <AuthorizedLayout>
          <Outlet />
        </AuthorizedLayout>
      )} */}
    </>
  );
}

export default observer(App);
